export const BUILD_TIME_HELP_PANELS_ENABLED = false;

/**
 * Feature flag for the NON-RENEWAL EPO help (Info) panels — wizard headers, discount strategy,
 * buyer payment schedule, units, configurations list/details, payment details. Their copy is not
 * yet reviewed, so they stay behind this flag. Resolved host-side from the build-time flag OR the
 * `epoHelpPanels` debug toggle.
 *
 * The renewal help panels are NOT behind this flag: their Info links live inside containers that
 * only render on renewal surfaces (the seller "Configure renewal terms" step behind
 * `epoRenewalEnabledSeller`; the buyer renewal-terms containers and renewal payment-schedule
 * preview, which render only when the offer carries seller-configured renewal terms). Their copy
 * went through the renewal FnF review, so they launch with renewal itself.
 */
export const isHelpPanelsEnabled = (debugPanelHelpPanels: boolean): boolean => BUILD_TIME_HELP_PANELS_ENABLED || debugPanelHelpPanels;
